import { useContext } from 'react'

import { FormSubmitContext } from './FormSubmitContext'

export const useFormSubmit = () => useContext(FormSubmitContext)
